import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  LinearProgress,
  Stack,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";

function AddAudioDialog({
  open,
  onClose,
  addingAudio,
  addAudioValues,
  setAddAudioValues,
  addAudioUploading,
  addAudioProgress,
  onSubmit,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => (addingAudio ? null : onClose)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Add Audio</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Title"
            value={addAudioValues.title}
            onChange={(e) =>
              setAddAudioValues((v) => ({ ...v, title: e.target.value }))
            }
            fullWidth
          />
          <TextField
            label="Description"
            value={addAudioValues.description}
            onChange={(e) =>
              setAddAudioValues((v) => ({
                ...v,
                description: e.target.value,
              }))
            }
            fullWidth
            multiline
            minRows={2}
          />
          <TextField
            select
            label="Category"
            value={addAudioValues.category}
            onChange={(e) =>
              setAddAudioValues((v) => ({ ...v, category: e.target.value }))
            }
            fullWidth
          >
            <MenuItem value="reflection">reflection</MenuItem>
            <MenuItem value="meditation">meditation</MenuItem>
            <MenuItem value="sciences">sciences</MenuItem>
          </TextField>
          <Box>
            <Typography variant="caption" sx={{ color: "#64748b" }}>
              Audio file (mp3/m4a/wav)
            </Typography>
            <input
              type="file"
              accept="audio/*"
              onChange={(e) =>
                setAddAudioValues((v) => ({
                  ...v,
                  file: e.target.files?.[0] || null,
                }))
              }
            />
          </Box>
          {addAudioUploading && (
            <Box sx={{ mt: 1 }}>
              <LinearProgress variant="determinate" value={addAudioProgress} />
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                {Math.round(addAudioProgress)}%
              </Typography>
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={addingAudio}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={addingAudio || !addAudioValues.file}
          onClick={onSubmit}
        >
          {addingAudio ? (
            <CircularProgress size={18} sx={{ color: "#fff" }} />
          ) : (
            "Add"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddAudioDialog;
